// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// PKCE: prevent stale-session autoRefreshToken from destroying code_verifier
// When the user returns from Google with ?code=xxx, the Supabase SDK may attempt
// an autoRefreshToken on the expired session it finds in localStorage BEFORE our
// useAuth hook runs. That refresh clears localStorage including the code_verifier,
// causing exchangeCodeForSession to fail (first login always requires two attempts).
//
// Fix: if an OAuth code is present in the URL, remove the stale session from
// localStorage synchronously before creating the client so autoRefreshToken has
// nothing to act on. The code_verifier key (sb-*-auth-token-code-verifier) is
// intentionally preserved as it is needed for the exchange.
(function clearStaleSessionBeforePkceExchange() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.has("code")) return;

    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (/^sb-.+-auth-token(\.\d+)?$/.test(key) && !key.endsWith("-code-verifier")) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // localStorage inaccessible (private mode, ITP) safe to ignore
  }
})();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    flowType: "pkce",
  }
});
